export default __webpack_public_path__ + "static/media/serbiana.b640115d.png";